export const PLAN_PAGO_CUOTA_STATE = {
    PENDIENTE: 440,
    PAGADO: 441,
    CANCELADO: 442,
    COMPENSADO: 443
}
